import { Module, ActionContext } from 'vuex'
import { RootState, MailGunServiceState } from './state_models'
import { MailGunAccount } from '../models';
import cloneDeep from "lodash-es/cloneDeep"
import { trackPendoEvent } from '../util/helper'

// let mailgunServiceListener;
// let companyMailGunServiceListener;

const getMailgunStoreSchema = (mailgunAccount: MailGunAccount) => {
  return {
    domain: mailgunAccount.domain,
    id: mailgunAccount.id,
    locationId: mailgunAccount.locationId,
    validateEmails: mailgunAccount.validateEmails
  }
}

export const mailgunServices: Module<MailGunServiceState, RootState> = {
  namespaced: true,
  state: { mailgunLocationWithErrors: undefined, locationId: undefined, mailgunCompanyWithErrors: undefined, companyId: undefined, locationMailgunAccount: undefined, companyMailgunAccount: undefined },
  getters: {
    // Since the topbar is loaded using reporting apis, this is obsolete. Confirm and remove
    locationMailGunErrorMsg: (state: MailGunServiceState, getters, rootState, rootGetters) => {
      if (state.mailgunLocationWithErrors) {
        const location = rootGetters['locations/getById'](state.locationId)
        return `There is a problem with the MailGun integration of ${location.name}.`;
      } else {
        return null;
      }
    },
    companyMailGunErrorMsg: (state: MailGunServiceState, getters) => {
      if (state.mailgunCompanyWithErrors) {
        return 'There is a problem with the MailGun integration of this agency.';
      } else {
        return null;
      }
    },
    locationMailgunAccount: (state: MailGunServiceState, getters) => {
      if (state.locationMailgunAccount) {
        return state.locationMailgunAccount;
      } else {
        return null;
      }
    },
    companyMailgunAccount: (state: MailGunServiceState, getters) => {
      if (state.companyMailgunAccount) {
        return state.companyMailgunAccount;
      } else {
        return null;
      }
    }
  },
  mutations: {
    setLocationError: (
      state: MailGunServiceState,
      payload: { mailgunAccountErrors: string, locationId: string }
    ) => {
      state.mailgunLocationWithErrors = payload.mailgunAccountErrors
      if (payload.locationId) {
        state.locationId = payload.locationId
      }
    },
    setCompanyServices: (
      state: MailGunServiceState,
      payload: { mailgunAccountErrors: string; companyId: string }
    ) => {
      state.mailgunCompanyWithErrors = payload.mailgunAccountErrors
      if (payload.companyId) {
        state.companyId = payload.companyId
      }
    },
    setLocationMailgunAccount: (
      state: MailGunServiceState,
      payload: { locationMailgunAccount: Object}
    ) => {
      state.locationMailgunAccount = payload.locationMailgunAccount
    },
    setCompanyMailgunAccount: (
      state: MailGunServiceState,
      payload: { companyMailgunAccount: Object}
    ) => {
      state.companyMailgunAccount = payload.companyMailgunAccount
    },
    clearLocation(state: MailGunServiceState) {
      // if (mailgunServiceListener) {
      //   mailgunServiceListener();
      // }

      state.mailgunLocationWithErrors = undefined
      state.locationId = undefined
    },
    clearCompany(state: MailGunServiceState) {
      // if (companyMailGunServiceListener) {
      //   companyMailGunServiceListener();
      // }

      state.mailgunCompanyWithErrors = undefined
      state.companyId = undefined
    }
  },
  actions: {
    async syncAll(
      context: ActionContext<MailGunServiceState, RootState>,
      locationId: string
    ) {
      if (!locationId) {
        context.commit('clearLocation')
        return
      }

      const mailgunAccount = await MailGunAccount.getByLocationId(locationId)
      if (mailgunAccount) {
        context.commit('setLocationError', {
          locationId: locationId,
          mailgunAccountErrors: mailgunAccount.mailgunError || undefined
        });
        context.commit('setLocationMailgunAccount', {
          locationMailgunAccount: cloneDeep(getMailgunStoreSchema(mailgunAccount)) || undefined
        });
      }

      if (context.state.locationId === locationId) {
        return context.state.mailgunLocationWithErrors
      }
    },
    async companySyncAll(
      context: ActionContext<MailGunServiceState, RootState>,
      companyId: string
    ) {
      if (!companyId) {
        context.commit('clearCompany')
        return
      }


      if (context.state.companyId === companyId) {
        return context.state.mailgunCompanyWithErrors
      }

      const mailgunAccount = await MailGunAccount.getByCompanyId(companyId)
      if (mailgunAccount) {
        context.commit('setCompanyMailgunAccount', {
          companyMailgunAccount: cloneDeep(getMailgunStoreSchema(mailgunAccount)) || undefined
        });
  
        context.commit('setCompanyServices', {
          companyId: companyId,
          mailgunAccountErrors: mailgunAccount.mailgunError || undefined
        });
      }

    },
    logout: {
      root: true,
      handler: (context: ActionContext<MailGunServiceState, RootState>) => {
        context.commit('clearLocation')
        context.commit('clearCompany')
      }
    },
    clearAll: {
      handler: (context: ActionContext<MailGunServiceState, RootState>) => {
        context.commit('clearLocation')
        context.commit('clearCompany')
      }
    }
  }
}
